import { render, staticRenderFns } from "./SkillWiseCandidateReport.vue?vue&type=template&id=19e5d077&scoped=true&"
import script from "./SkillWiseCandidateReport.vue?vue&type=script&lang=js&"
export * from "./SkillWiseCandidateReport.vue?vue&type=script&lang=js&"
import style0 from "./SkillWiseCandidateReport.vue?vue&type=style&index=0&id=19e5d077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e5d077",
  null
  
)

export default component.exports